'use strict';
module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);



//////////////////
// WEBPACK FOOTER
// ../node_modules/strict-uri-encode/index.js
// module id = 169
// module chunks = 0 1 2 3 4 7 8 9 10 11 12 13 14 15 16 17 18 20 21 22 23 24 25 26